{
  "Thank you for filling in the form.": "Merci d'avoir rempli le formulaire.",
  "There was an error in your submission, please try again in a few seconds. If the issue persists, please contact us.": "Il y a eu une erreur dans votre soumission, veuillez réessayer dans quelques secondes. Si le problème persiste, veuillez nous contacter."
}
